<template>
  <div class="org-members">
    <nav class="tip-title __fs-16 _fw-500">组织成员</nav>
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <div class="OrganImg">
          <div class="img-contain">
            <img class="img" :src="formatAliyunPath(item.src)" @click="showHeader(item)"/>
          </div>
        </div>
        <div class="content">
          <p class="name __line1 __fs-14">{{item.name}}</p>
          <p class="job __fs-10 __cor-8 __ellipsis __line2">{{item.job}}</p>
        </div>
      </li>
    </ul>
    <van-overlay :show="show" @click="show = false" class="wrapper">
      <div class="block" @click.stop>
        <img class="img" :src="formatAliyunPath(showSrc)">
      </div>
      <div class="square" @click.stop>
        <div class = "square_content">
          <div class = "content_name">{{name}}</div>
          <div class = "content_job"> {{job}}</div>
          <div class = "content_introduce">{{introduce}}</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'OrgMembers',
  props: {
    list: {
      type: Array,
    }
  },
  data () {
    return {
      show: false,
      showSrc: '',
      job: '',
      name: '',
      introduce: '',
    }
  },
  methods: {
    showHeader (item) {
      this.showSrc = item.src
      this.job = item.job
      this.name = item.name
      this.introduce = item.introduce
      this.show = true
    },
    // 点击swiper
    handleClickSlide (item) {
      this.$emit('handle-click-wonderful', item)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  },
}
</script>

<style scoped lang="scss">
.org-members {
  margin: 36px 20px 0px 20px;
  .tip-title {
    padding-left: 8px;
    border-left: 3px solid $main-color;
    border-radius: 2px;
    color: #282828;
    margin-bottom: 25px;
  }
  ul {
    width: 100%;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    display:-webkit-box;
    &::-webkit-scrollbar {
      display: none;
    }
    li {
      display: block;
      width: 120px;
      height: 170px;
      background: #FFFFFF;
      box-shadow: 8px 13px 23px 0px rgba(130, 130, 130, 0.15);
      &:not(:last-child) {
        margin-right: 20px;
      }
      .OrganImg {
        width: 100%;
        height: 116px;
        overflow: hidden;
        position: relative;
        .img-contain{
          position: absolute;
          width: 100px;
          height: 100px;
          top: 10px;
          left: 10px;
          border-radius: 100%;
          overflow: hidden;
          img{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-44%);
            display: block;
            max-height: 120px;
          }
        }
      }
      .content {
         width:100%;
         height: 54px;
        .name {
          opacity: 1;
          font-size: 16px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #1c1f25;
          line-height: 16px;
          height: 16px;
          letter-spacing: 1px;
          margin-bottom: 7px;
        }
        .job {
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #828282;
          line-height: 12px;
          height: 12px;
          letter-spacing: 0px;
        }
      }
    }
  }
  .wrapper {
    .block {
      position:absolute;
      left: 138px;
      top: 177px;
      width: 100px;
      height: 100px;
      background: #ffffff;
      padding: 10px 10px 0 10px;
      box-sizing: border-box;
      overflow: hidden;
      text-align: center;
      border-radius: 100%;
      z-index:10;
      .img{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-44%);
        display: block;
        max-height: 120px;
      }
    }
    .square {
      position:absolute;
      top:214px;
      left:87px;
      width: 200px;
      height: 215px;
      opacity: 1;
      background: #ffffff;
      border-radius: 5px;
      z-index:0;
      .square_content {
        padding: 75px 21px 35px 21px;
        .content_name{
          opacity: 1;
          font-size: 17px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #1c1f25;
          letter-spacing: 1px;
          overflow: hidden; // 文字超过三行省略号处理
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .content_job{
          padding: 8px 0 22px 0;
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #666666;
          letter-spacing: 0px;
          overflow: hidden; // 文字超过三行省略号处理
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .content_introduce {
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #666666;
          line-height: 18px;
          letter-spacing: 0px;
          overflow: hidden; // 文字超过三行省略号处理
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

}
</style>
